<template>
<div class="shareinfo">
    <div>
        <img v-lazy="item.posterkeyurl" alt="" class="img">
    </div>
    <el-button type="primary" @click="download">下载主页海报</el-button>
</div>
</template>

<script>
import {downloadImage} from 'common/js/tools'
import {getMPPosterInfo} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'shareinfo',
    data() {
        return {
            item: {
                posterkeyurl: ''
            }
        }
    },
    mounted() {
    },
    methods: {
        init() {
            if (!this.item.posterkeyurl) {
                this._getPoster()
            }
        },
        download() {
            downloadImage(this.item.posterkeyurl, `${this.brandBusiness.hostname}-主页海报`)
        },
        _getPoster() {
            this.setLoading(true)
            getMPPosterInfo({
                data: {
                    postertype: 26,
                    keyid: `2_${this.brandBusiness.hostid}`
                },
                success: data => {
                    this.item.posterkeyurl = data.data.posterurl
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['brandBusiness'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.shareinfo {
    display: flex;
    .img{
        width: 200px;
        height: 356px;
        margin-right: 30px;
    }
}
</style>
